import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";

const WdsfCouple = ({ couple, t }) => (
    <Box>
        <List dense>
            <ListItem>
                <ListItemText primary={`${couple.name}`} secondary={t("reg.name")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${couple.ageGroup}`} secondary={t("reg.age_group")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${couple.country}`} secondary={t("reg.country")} />
            </ListItem>
        </List>
    </Box>
);

export default WdsfCouple;
